import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Iframe, Layout } from '~/ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};

const MDXLayout = function PageLayout({
  children
}) {
  return <Layout>{children}</Layout>;
};

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "projects"
    }}>{`Projects`}</h2>
    <p>{`Github: `}<a parentName="p" {...{
        "href": "https://github.com/chrisrzhou"
      }}>{`https://github.com/chrisrzhou`}</a></p>
    <h3 {...{
      "id": "active"
    }}>{`Active`}</h3>
    <h4 {...{
      "id": "unified-doc"
    }}><a parentName="h4" {...{
        "href": "https://unified-doc.netlify.app"
      }}>{`unified-doc`}</a></h4>
    <p>{`A unified way to work with all kinds of documents`}</p>
    <h4 {...{
      "id": "tdast"
    }}><a parentName="h4" {...{
        "href": "https://github.com/tdast/tdast"
      }}>{`tdast`}</a></h4>
    <p>{`Tabular data abstract syntax tree`}</p>
    <h4 {...{
      "id": "react-globe"
    }}><a parentName="h4" {...{
        "href": "https://react-globe.netlify.app"
      }}>{`react-globe`}</a></h4>
    <p>{`Create beautiful and interactive React + ThreeJS globe visualizations with ease.`}</p>
    <h4 {...{
      "id": "react-wordcloud"
    }}><a parentName="h4" {...{
        "href": "https://react-wordcloud.netlify.app"
      }}>{`react-wordcloud`}</a></h4>
    <p>{`Simple React + D3 wordcloud component with powerful features.`}</p>
    <h4 {...{
      "id": "google-globe-trends"
    }}><a parentName="h4" {...{
        "href": "https://google-globe-trends.netlify.app"
      }}>{`google-globe-trends`}</a></h4>
    <p>{`Create beautiful and interactive Google Trends globe visualizations with ease. Built with `}<inlineCode parentName="p">{`react-globe`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "planned"
    }}>{`Planned`}</h3>
    <h4 {...{
      "id": "surveyless"
    }}><a parentName="h4" {...{
        "href": "https://surveyless.netlify.app"
      }}>{`surveyless`}</a></h4>
    <p>{`Build, run, and analyze simple serverless surveys`}</p>
    <h3 {...{
      "id": "archived"
    }}>{`Archived`}</h3>
    <h4 {...{
      "id": "qraffiti"
    }}><a parentName="h4" {...{
        "href": "https://qraffiti.netlify.app"
      }}>{`qraffiti`}</a></h4>
    <p>{`Fun app to generate QR codes`}</p>
    <h4 {...{
      "id": "wordcloud-generator"
    }}><a parentName="h4" {...{
        "href": "https://wordcloud-generator.netlify.app"
      }}>{`wordcloud-generator`}</a></h4>
    <p>{`Generator wordclouds.  Built with `}<inlineCode parentName="p">{`react-wordcloud`}</inlineCode>{` and `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{`.`}</p>
    {
      /* definitions */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      